module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/seperation-phone-1.695ccc3c.png";